import { GlButton, GlDisclosureDropdown, GlSearchBoxByType, GlTooltipDirective, GlAnimatedSmileIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { findLastIndex } from 'lodash-es';
import { getEmojiCategoryMap, state } from '../index.js?vue3';
import { __ } from '~/locale';
import { CATEGORY_NAMES, CATEGORY_ICON_MAP, FREQUENTLY_USED_KEY } from '../constants';
import EmojiList from './emoji_list.vue?vue3';
import VirtualList from './virtual_list.vue?vue3';
import { addToFrequentlyUsed, getEmojiCategories, hasFrequentlyUsedEmojis } from './utils.js?vue3';
export default {
    name: 'EmojiPicker',
    components: {
        GlButton,
        GlDisclosureDropdown,
        GlSearchBoxByType,
        GlAnimatedSmileIcon,
        VirtualList,
        EmojiList
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        newCustomEmojiPath: {
            default: ''
        }
    },
    props: {
        toggleClass: {
            type: [
                Array,
                String,
                Object
            ],
            required: false,
            default: ()=>[]
        },
        toggleCategory: {
            type: String,
            required: false,
            default: null
        },
        dropdownClass: {
            type: [
                Array,
                String,
                Object
            ],
            required: false,
            default: ()=>[]
        },
        right: {
            type: Boolean,
            required: false,
            default: true
        },
        customEmojiPath: {
            type: String,
            required: false,
            default: ''
        },
        buttonTitle: {
            type: String,
            required: false,
            default: null
        },
        toggleAriaLabel: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'click',
        'shown',
        'hidden'
    ],
    data () {
        return {
            isVisible: false,
            isHovered: false,
            isFocused: false,
            currentCategory: 0,
            searchValue: '',
            scrollTop: 0
        };
    },
    computed: {
        newEmojiPath () {
            return this.newCustomEmojiPath || this.customEmojiPath;
        },
        categoryNames () {
            return CATEGORY_NAMES.filter((c)=>{
                if (c === FREQUENTLY_USED_KEY) return hasFrequentlyUsedEmojis();
                if (c === 'custom') return !state.loading && getEmojiCategoryMap().custom.length > 0;
                return true;
            }).map((category)=>({
                    name: category,
                    icon: CATEGORY_ICON_MAP[category]
                }));
        },
        placement () {
            return this.right ? 'bottom-end' : 'bottom-start';
        },
        smileIcon () {
            return this.isHovered || this.isFocused || this.isVisible;
        }
    },
    methods: {
        async scrollToCategory (categoryName) {
            const categories = await getEmojiCategories();
            const { top } = categories[categoryName];
            this.scrollTop = top;
        },
        selectEmoji ({ category, emoji }) {
            this.$emit('click', emoji);
            this.$refs.dropdown.close();
            if (category !== 'custom') {
                addToFrequentlyUsed(emoji);
            }
        },
        onSearchInput () {
            if (this.$refs.virtualList) {
                this.scrollTop = 0;
            }
        },
        async onScroll ({ offset }) {
            this.scrollTop = offset;
            const categories = await getEmojiCategories();
            const categoryKeys = this.categoryNames.map(({ name })=>name);
            this.currentCategory = findLastIndex(categoryKeys, (name)=>{
                // category may be undefined if categoryNames includes a tab (e.g. frequently_used)
                // whose data has not yet been loaded into the categories map
                const category = categories[name];
                return category && offset >= category.top;
            });
        },
        onShow () {
            this.isVisible = true;
            this.$emit('shown');
        },
        onHide () {
            this.isVisible = false;
            this.currentCategory = 0;
            this.searchValue = '';
            this.$emit('hidden');
        },
        onButtonHovered () {
            this.isHovered = true;
        },
        onButtonHoverLeave () {
            this.isHovered = false;
        },
        onButtonFocused () {
            this.isFocused = true;
        },
        onButtonFocusLeave () {
            this.isFocused = false;
        }
    },
    i18n: {
        addReaction: __('Add reaction'),
        createEmoji: __('Create new emoji')
    }
};
